import { LocalStorageService } from 'services/data-handler-services/web-storage-service';
import Controller from 'controllers/base/controller';
import Backbone from 'backbone';

export default Controller.extend({
  index: function () {
    const originFragment = LocalStorageService.getItem('originFragment');
    if (originFragment) {
      this.redirectTo({ url: originFragment });
    } else {
      this.redirectTo({ url: '' });
    }
    Backbone.history.start(); // stopped by navigation-service so the reload route is not in the history
    LocalStorageService.removeItem('originFragment');
  },
});
